module.exports = __webpack_public_path__ + "bf1ad972443546ed19c3d294bfa7f68a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-leo-02.jpg
 ** module id = 355
 ** module chunks = 0
 **/